import "./styles/SuccessPage.scss";
import { useTranslation } from "react-i18next";

const CheckMailPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <h1 className="title">{t("signup__success_title")}</h1>
      <p style={{ margin: 20 }} className="text">
        {t("signup__success_activationText")}
        <br />
      </p>
    </>
  );
};

export default CheckMailPage;
